<template>
  <div>
    <Title :pages="[{ icon: 'file-invoice', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <div class="content-main">
        <v-tabs v-model="tab" style="background-color: white">
          <v-tab v-for="item in items" :key="item.key">
            {{ item.tab }}
          </v-tab>
        </v-tabs>

        <v-tabs-window v-model="tab">
          <v-tabs-window-item key="0">
            <Ingresos></Ingresos>
          </v-tabs-window-item>
          <v-tabs-window-item key="1">
            <Egresos></Egresos>
          </v-tabs-window-item>
          <v-tabs-window-item key="2">
            <IngresosDetalle></IngresosDetalle>
          </v-tabs-window-item>
          <v-tabs-window-item key="3">
            <EgresosDetalle></EgresosDetalle>
          </v-tabs-window-item>
          <v-tabs-window-item key="4">
            <Ocupacion></Ocupacion>
          </v-tabs-window-item>
          <v-tabs-window-item key="5">
            <StockProducto></StockProducto>
          </v-tabs-window-item>
          <v-tabs-window-item key="6">
            <MovimientoDeStock></MovimientoDeStock>
          </v-tabs-window-item>
        </v-tabs-window>
      </div>
    </v-container>
  </div>
</template>

<script>
import Ingresos from "./Ingresos.vue";
import Egresos from "./Egresos.vue";
import Ocupacion from "./Ocupacion.vue";
import StockProducto from "./StockProducto.vue";
import IngresosDetalle from "./IngresosDetalle.vue";
import EgresosDetalle from "./EgresosDetalle.vue";
import MovimientoDeStock from "./MovimientoDeStock.vue";
import Title from "@/components/Title.vue";

export default {
  mixins: [],
  components: { Title, Ingresos, Egresos, IngresosDetalle, EgresosDetalle, Ocupacion, StockProducto, MovimientoDeStock },
  data() {
    return {
      page_title: "Reportes",
      tab: 0,
      list: [],
      items: [
        { tab: "Ingresos", key: 0 },
        { tab: "Egresos", key: 1 },
        { tab: "Detalle de Ingresos", key: 2 },
        { tab: "Detalle de Egresos", key: 3 },
        { tab: "Ocupacion", key: 4 },
        { tab: "Stock Producto", key: 5 },
        { tab: "Movimiento de Stock", key: 6 },
      ],
    };
  },
  mounted() {},
  methods: {},
};
</script>
